// extracted by mini-css-extract-plugin
export var layout = "Faq-module--layout--7a6b5";
export var wrapper = "Faq-module--wrapper--5b70a";
export var description = "Faq-module--description--e1c03";